import { Injectable, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { AppService } from "../../core/services/app.service";
import { LocationService } from "../../shared/services/location.service";
import Swal from "sweetalert2";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class UploadPhotoService {
  public file: File;
  public original: string;
  public fileTypes = ["image/jpeg", "image/jpg", "image/png", "image/heic", "image/heif"];
  public uploadPhotoAPI = AppService.getApiUrl() + "/api/photos/";
  constructor(
    private router: Router,
    private http: HttpClient,
    private toastr: ToastrService,
    private locationService: LocationService
  ) {}

  public upload(formData, formDataRelated?, isChecked?, isEdit?) {
    if (formDataRelated && formDataRelated.get("wasRelated")) {
      this.http.post(this.uploadPhotoAPI + `?photoRelated=true`, formDataRelated).subscribe(
        res => {
          if (res["Data"] && res["Data"]["id"]) {
            formData.append("photoRelated", res["Data"]["id"]);
            this.uploadOriginal(formData, isChecked, isEdit);
          }
        },
        error => {
          this.toastr.error(error.error.Message, "Upload related photo failed");
          if (!isEdit) {
            if (formData.get("locationId")) {
              this.locationService.deleteById(formData.get("locationId")).subscribe();
            }
          }
        }
      );
    } else {
      this.uploadOriginal(formData, isChecked, isEdit);
    }
  }

  public uploadOriginal(formData, isChecked, isEdit) {
    // let url = AppService.getApiUrl() + "/api/photos";
    let url = AppService.getApiUrl() + "/api/photos/upload";
    if (formData.get("groupId")) {
      url = url + `?groupId=${formData.get("groupId")}`;
    }
    let req = isEdit
      ? this.http.put(this.uploadPhotoAPI + formData.get("id"), formData)
      : this.http.post(url, formData);

    req.subscribe(
      data => {
        this.toastr.success(isEdit ? "Photo has been updated." : "Photo uploaded successfully", "SUCCESS");
        window.location.href = environment["site"] + environment["prefixDomain"] + "photo/" + data["Data"]["id"];
        // console.log(data);

        //Show facebook share dialog
        if (isChecked) {
          const trimName = data["Data"]["photographerName"].toLowerCase().replace(/ /g, "");
          window.open(
            "https://www.facebook.com/dialog/share?app_id=546692462944629&display=popup&href=" +
              data["Data"]["thumbnail"] +
              "&hashtag=%23" +
              trimName +
              "&quote=Photo by: " +
              data["Data"]["photographerName"] +
              " - @" +
              trimName
          );
        }
      },
      error => {
        if (!isEdit) {
          if (formData.get("locationId")) {
            this.locationService.deleteById(formData.get("locationId")).subscribe();
          }
        }
        if (error.status == 406 && error.error.Message === "Reach the limit of photo uploads a day") {
          Swal.fire({
            title: "You’ve reached your daily limit!",
            html: `
                    <p>You've shared 3 fantastic photos today. We’d love to see more from you, come back tomorrow to share more of your favorites! </p>
                    <br>
                    <p>In the meantime, why not check out others’ photos? Engage with the community and leave some positive feedback.</p>
                    <p>Remember, the more feedback you give, the more you’ll get back on your own posts!</p>`,
            showCancelButton: false,
            confirmButtonText: "Ok",
          }).then(result => {
            if (result.value) {
              this.router.navigate(["/"]);
            }
          });
        } else {
          this.toastr.error(error.error.Message, isEdit ? "Edit failed!" : "Upload failed");
        }
      }
    );
  }

  public roundExif(a, b) {
    if (a && b) {
      return Math.round((a / b) * 10) / 10;
    }
  }
}
